import axios from 'axios';

export const HTTP = axios.create({

    baseURL: process.env.VUE_APP_ROOT_API, //http://vvg.salesintranet.com/api/v1
    headers: {
      'Content-Type': 'application/json',
    }
});
export const HTTPGUZZLE = axios.create({

    // baseURL: "https://www.velocitytruckcenters.com", //http://vvg.salesintranet.com/api/v1
    baseURL: process.env.VUE_APP_SSO_URL,
    headers: {
      'Content-Type': 'application/json',
    }
});